<template>
  <AbaDownload :titulo="titulo" v-if="!loading">
    <div slot="subtitulo">
      <span class="segunda-cor-fonte"> Filtros aplicados: </span>
      {{ textoSubtitulo }}
    </div>
    <TabelaDownload
      v-if="qtTotal > 0"
      @baixar-todos="baixarTodos"
      @baixar-selecionados="baixarSelecionados"
      @baixar="baixar"
      @input="v => (checkbox = v)"
      @trocar-pagina="trocarPagina"
      :checkbox="checkbox"
      :loadings="loadings"
      :qtTotal="qtTotal"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :rows="rows"
    />
    <div class="titulo negrito my-auto" v-else>NENHUM ARQUIVO ENCONTRADO</div>
  </AbaDownload>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaDownloadMixin from "../AbaDownloadMixin";

export default {
  mixins: [AbasMixin, AbaDownloadMixin],
  data() {
    let arr = [];

    return {
      checkbox: [],
      downloads: [],
      loadings: [],
      qtTotal: 0,
      pagina: 1,
      qtPaginas: 1,
      rows: [],
      loading: false,
      arrMock: arr
    };
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.resetarVariaveis();
      this.sleep(500).finally(() => {
        this.inicializarTabela();
      });
    },
    resetarVariaveis() {
      this.checkbox = [];
      this.downloads = [];
      this.loadings = [];
    },
    inicializarTabela() {
      this.loading = true;
      this.rows = [];

      this.getListaPtuErro({
        ...this.filtroComputed,
        pagina: this.pagina
      })
        .then(res => {
          const {
            conteudo,
            numeroPagina,
            totalElementos,
            totalPaginas
          } = res.data;

          conteudo.forEach(e => {
            const { id, nomeArquivo, data } = e;

            this.rows.push({
              id,
              nomeArquivo,
              data: this.$helpers.formatadorHorario(data)
            });
          });

          this.qtTotal = totalElementos;
          this.qtPaginas = totalPaginas;
          this.pagina = numeroPagina;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    trocarPagina(pagina) {
      this.pagina = pagina;
      this.inicializarTabela();
    },
    baixarTodos() {
      this.$store.commit("setLoadingModal", true);
      this.getDownloadTodosPtuErro(this.filtroComputed)
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    baixarSelecionados() {
      this.$store.commit("setLoadingModal", true);
      this.getDownloadSelecionadoPtuErro({
        ...this.filtroComputed,
        arquivos: this.checkbox
      })
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });

      this.checkbox = [];
    },
    baixar(id) {
      if (!this.downloads.includes(id)) {
        this.downloads.push(id);
      }

      this.atualizarLoading(id, 0);

      const intervalo = this.progressoFake(id);

      const objetoProgresso = {
        onDownloadProgress: progressEvent => {
          let porcentagem = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          if (porcentagem === 100) {
            clearInterval(intervalo);
            this.atualizarLoading(id, 100);

            this.sleep(300).finally(() => {
              this.atualizarLoading(id, 101);
            });
          }
        }
      };

      this.sleep(100).finally(() => {
        this.getDownloadSelecionadoPtuErro(
          {
            ...this.filtroComputed,
            arquivos: [id]
          },
          objetoProgresso
        )
          .then(res => {
            if (res.status === 204) return;
            this.$helpers.baixarArquivo(
              res.data,
              res.headers["content-disposition"]
            );
          })
          .catch(() => {
            this.atualizarLoading(id, -1);
          });
      });
    },

    progressoFake(id) {
      let that = this;

      let progressoAtual = 0,
        valorProgresso = 0.3;

      const intervalo = setInterval(function() {
        progressoAtual += valorProgresso;
        let progresso = Math.floor(
          Math.round((Math.atan(progressoAtual) / (Math.PI / 2)) * 100 * 1000) /
            1000
        );
        that.atualizarLoading(id, progresso);

        if (progresso >= 70) {
          valorProgresso = 0.1;
        }
      }, 150);

      return intervalo;
    },

    atualizarLoading(id, valor) {
      this.$set(this.loadings, id, valor);
    }
  },
  computed: {
    filtroComputed() {
      const { codigoUnimed, competencia } = this.objetoFiltro;

      return { codigoUnimed, competencia };
    },
    textoSubtitulo() {
      const { descricaoPrestador, competencia } = this.objetoFiltro;

      if (!competencia) {
        return `${this.letraMaiusculaCadaPalavra(descricaoPrestador)}`;
      }

      return `${this.letraMaiusculaCadaPalavra(
        descricaoPrestador
      )}, ${this.$helpers.formatadorData(competencia, "MMMM [de] YYYY")}.`;
    }
  }
};
</script>

<style></style>
